import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { ToolsStore } from '../stores/ToolsStore';
import { SceneStore } from '../stores/SceneStore';
import { StatsEventAction, Stats } from '../utils/Stats';
import { ToolsActions } from '../actions/ToolsActions';
import { SceneActions } from '../actions/SceneActions';
import { AppHelper } from '../utils/AppHelper';
import { DownloadHelper } from '../utils/DownloadHelper';
import { FloorPlanActions } from '../actions/FloorPlanActions';
import { ClickButton } from './ClickButton';
import { CoreTooltip } from './CoreTooltip';

import core = egr.wcf.core;
import { GlobalHelper } from '../utils/GlobalHelper';
import { VisibilityActions } from '../actions/VisibilityActions';
import { PopupMenu } from '../constants/Enums';

interface ToolbarButtonProps {
    name: string;
    label: string;
    disabled?: boolean;
}

interface ToolbarButtonState {
    active: boolean;
}

export class ToolbarButton extends BaseComponent<ToolbarButtonProps, ToolbarButtonState> {
    public componentWillMount(): void {
        this.addStoreListener(ToolsStore, this.onChange);
        this.addStoreListener(SceneStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        return (
            <ClickButton
                className={this.cssClass()}
                callback={this.onClick}
                noAnimate={this.props.name === 'download-image' || this.props.name === 'floorplan'}
            >
                {this.props.label != null ? <CoreTooltip config={{label: this.props.label}}/> : null}
            </ClickButton>
        );
    }

    protected onChange = (): void => {
        let active: boolean = false;
        switch (this.props.name) {
            case 'smartextra':
                active = ToolsStore.getState().smartPopup != null;
                break;
            case 'cam-perspective':
                active = ToolsStore.getState().camera === core.view.CameraMode.Perspective;
                break;
            case 'cam-top':
                active = ToolsStore.getState().camera === core.view.CameraMode.Top;
                break;
            case 'cam-front':
                active = ToolsStore.getState().camera === core.view.CameraMode.Front;
                break;
            case 'multiselect':
                active = ToolsStore.getState().multiSelect;
                break;
            case 'rectselect':
                active = ToolsStore.getState().rectangleSelect;
                break;
            case 'send':
                active = ToolsStore.getState().sendImage === 'send';
                break;
            case 'snapshot':
                active = ToolsStore.getState().sendImage === 'snapshot';
                break;
            case '2d':
                active = SceneStore.getState().activeView != null && GlobalHelper.activeView.cameraControl.cameraMode === core.view.CameraMode.Top;
                break;
            case '3d':
                active = SceneStore.getState().activeView != null && GlobalHelper.activeView.cameraControl.cameraMode === core.view.CameraMode.Perspective;
                break;
            default:
                break;
        }
        this.setState({
            active: active
        });
    };

    protected onClick = (): void => {
        let action: StatsEventAction | undefined;
        let actionLabel: string | undefined;
        switch (this.props.name) {
            case 'smartextra':
                if (this.state.active) {
                    ToolsActions.hideSmartExtra();
                } else {
                    ToolsActions.showSmartExtra();
                }
                break;
            case 'cam-perspective':
            case '3d':
                ToolsActions.setCamera(core.view.CameraMode.Perspective);
                break;
            case 'cam-top':
            case '2d':
                ToolsActions.setCamera(core.view.CameraMode.Top);
                break;
            case 'cam-front':
                ToolsActions.setCamera(core.view.CameraMode.Front);
                break;
            case 'undo':
                action = this.props.name;

                SceneActions.undo();
                break;
            case 'redo':
                action = this.props.name;

                SceneActions.redo();
                break;
            case 'multiselect':
                action = 'multi select';

                ToolsActions.setMultiSelect(!this.state.active);
                break;
            case 'rectselect':
                action = 'rectangular select';

                ToolsActions.startRectangleSelect();
                break;
            case 'clone':
                action = 'duplicate';

                SceneActions.cloneSelectedElements();
                break;
            case 'snapshot':
                action = 'save';
                actionLabel = 'picture';

                ToolsActions.sendImage('snapshot');
                AppHelper.shareScreenshot(true).then(() => {
                    ToolsActions.sendImage(null);
                });
                break;
            case 'send':
                action = 'share';
                actionLabel = 'picture';

                ToolsActions.sendImage('send');
                AppHelper.shareScreenshot(false).then(() => {
                    ToolsActions.sendImage(null);
                });
                break;
            case 'download-image':
                DownloadHelper.downloadScreenshot();
                break;
            case 'floorplan':
                FloorPlanActions.getImageFile();
                break;
            case 'tools':
                VisibilityActions.setPopupMenu(PopupMenu.TOOLS_SETUP);
                break;
            case 'basearea-floorplan':
                VisibilityActions.setPopupMenu(PopupMenu.ENVIRONMENT_FLOORPLAN_SETUP);
                break;
            default:
                break;
        }

        if (action != null) {
            Stats.sendEvent({
                category: 'Interaction',
                action: action,
                label: actionLabel
            });
        }
    };

    protected cssClass = (): string => {
        const result: Array<string> = ['toolbar-button'];
        result.push('toolbar-button-' + this.props.name);
        if (this.state.active) {
            result.push('toolbar-button-state-active');
        }

        if (this.props.disabled) {
            result.push('toolbar-button-state-disabled');
        }
        return result.join(' ');
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ToolbarButton.tsx